module.exports = __webpack_public_path__ + "img/ic_commodity.184771e1.svg";